import React from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import submitForm from './components/submitForm';
import Form from './components/Form';

const Authenticate = ({ next }) => {
  const methods = useForm({
    defaultValues: {
      codeInputs: ['', '', '', '', '', '']
    },
    mode: 'onSubmit'
  });

  const { setError } = methods;

  const onSubmit = async (values) => {
    try {
      await submitForm(values, next, setError);
    } catch (err) {
      console.error('Authentication failed:', err);
    }
  };

  return (
    <FormProvider {...methods}>
      <Form onSubmit={onSubmit} />
    </FormProvider>
  );
};

export default Authenticate;
